import React, { useEffect, useState } from "react";
import projectImg from "../../assets/img/project-img.png";
import ToolBar from "../common-web/ToolBar";
import loader from "../../assets/img/loader.gif";

export default function TdViewerContent() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // simulate loading for 5 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);

    // cleanup
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex-1 flex flex-col relative h-[calc(100vh-50px)] bg-white">
      {/* Toolbar */}
      <ToolBar />

      {/* Main Content */}
      <div className="flex-1  flex items-center justify-center overflow-hidden">
        {loading ? (
          <div>
            <img src={loader} alt="Loading..." className="max-w-[140px]" />
          </div>
        ) : (
          <img
            src={projectImg}
            alt="Project"
            className="h-full w-full object-cover"
          />
        )}
      </div>
    </div>
  );
}
